// extracted by mini-css-extract-plugin
export var icon = "_qr-0";